export const WEDDING_CAKE_OPTIONS_default = [
    {
        strike_bonifie: 1.2,
        barriere_haute: 1.3, 
        barriere_basse: 1.1,
        cours_a_terme: 1.15
    },
    {
        strike_degrade: 1.15,
        cours_a_terme: 1.2
    },
    {
        strike_bonifie: 1.2, 
        strike_degrade: 1.15, 
        barriere_basse: 1.1, 
        barriere_haute: 1.3, 
        cours_a_terme: 1.18
    },
    {
        strike_bonifie: 1.2, 
        barriere_basse: 1.1, 
        barriere_haute: 1.3, 
        cours_a_terme: 1.18
    },
    {
        strike_degrade: 1.2, 
        cours_a_terme: 1.18
    },
    {
        strike_bonifie: 1.15, 
        strike_degrade: 1.2, 
        barriere_basse: 1.1, 
        barriere_haute: 1.3, 
        cours_a_terme: 1.18
    }
]


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/WeddingCakeOptions.ts